import React from "react";
import { Grid2, useMediaQuery } from "@mui/material";
import Lottie from "react-lottie";
import styles from "./ProcessingPage.module.scss";
import Create from "../../../../../../GlobalAssets/Animations/Create.json";

export default function ProcessingPage() {
  const isMobile = useMediaQuery("(max-width:768px)");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Create,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid2 className={styles.ProcessingPageContainer}>
      <Lottie
        options={defaultOptions}
        height={isMobile ? 270 : 350}
        width={isMobile ? 300 : 435}
      />
    </Grid2>
  );
}
